import { Container, Typography } from '@material-ui/core';
import React from 'react';

interface TabPanelProps {
  children: React.ReactNode;
  index: any;
  value: any;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index } = props;

  return (
    <div>
      {value === index && (
        <Container>
          <Typography>{children}</Typography>
        </Container>
      )}
    </div>
  );
};

export default TabPanel;
